import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { User } from 'anchor-shared/lib/model/entity/user';
import { Observable, Subscription } from 'rxjs';
import { UserSearchResult } from 'anchor-shared/lib/model/interface/userSearchResult';
import { BoatOwnerDAO } from '../../../../../../../core/services/dao/boatOwnerDAO';
import { UserSearchDialogService } from '../../../../../../shared/dialogs/user-search-dialog/user-search-dialog-service';
import { VesselDAO } from '../../../../../../../core/services/dao/vesselDAO';
import { Router } from '@angular/router';
import { unsubscribeFromAll } from '../../../../../../../core/pure-functions/rx-helper';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as moment from 'moment';

@Component({
  selector: 'app-admin-form',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
})
export class AdminFormComponent implements OnInit, OnDestroy {
  @Input() user: User;
  @Input() vesselId: number;
  @Input() ownerId: number;
  // @Input() logs;
  // public rowData;
  // public columnDefs;
  subs: Subscription[] = [];

  constructor(
    private vesselDAO: VesselDAO,
    private boatOwnerDAO: BoatOwnerDAO,
    private userSearchDialogService: UserSearchDialogService,
    private router: Router,
    private snackBar: MatSnackBar,
  ) {
    // boat ownership
    this.searchFxn = this.searchFxn.bind(this);
  }

  ngOnInit() {
    // vessel history
    // this.rowData = this.formatDates();
    // this.columnDefs = this.createColumnDefs();
  }

  ngOnDestroy() {
    unsubscribeFromAll(this.subs);
  }

  // boat ownership
  goToUser() {
    this.router.navigate(['manage/admin/user/edit/' + this.user.id]);
  }

  searchFxn(searchText): Observable<UserSearchResult[]> {
    return this.boatOwnerDAO.adminBoatOwnerSearch(searchText);
  }

  userSearchClick(): void {
    const sub = this.userSearchDialogService
      .open({ searchFxn: this.searchFxn, userType: 'Boat Owners' })
      .subscribe((userSelection) => {
        if (userSelection) {
          if (userSelection.id === this.user.id) {
            this.snackBar.open(
              'That boat owner already has ownership of this vessel.',
              null,
              { duration: 4000, verticalPosition: 'top' },
            );
            return;
          }

          this.vesselDAO
            .transferVessel(this.vesselId, userSelection.ownerId, this.ownerId)
            .subscribe(() => {
              this.user.firstName = userSelection.firstName;
              this.user.lastName = userSelection.lastName;
              this.user.email = userSelection.email;
              this.user.phoneNumber = userSelection.phoneNumber;
              this.user.id = userSelection.id;
              this.ownerId = userSelection.ownerId;
              this.snackBar.open(
                'Owner of this vessel has been changed.',
                null,
                { duration: 4000, verticalPosition: 'top' },
              );
            });
        }
      });
    this.subs.push(sub);
  }

  // vessel history
  // public formatDates() {
  //   const _logs = [];
  //   this.logs?.forEach((log) => {
  //     Object.entries(log.ancillary.changes).forEach(
  //       ([key, value]: [key: string, value: any]) => {
  //         if (
  //           (typeof value.newValue !== 'object' || !value.newValue) &&
  //           (typeof value.oldValue !== 'object' || !value.oldValue)
  //         ) {
  //           _logs.push({
  //             name: log.name,
  //             description: key,
  //             oldValue: value.oldValue,
  //             newValue: value.newValue,
  //             username: log.firstName ? `${log.firstName} ${log.lastName}` : '',
  //             createdAt: moment(log.createdAt).format('MM-DD-YY HH:MM'),
  //           });
  //         }
  //       },
  //     );
  //   });
  //   return _logs;
  // }

  // public createColumnDefs(): any {
  //   return [
  //     {
  //       headerName: 'Name',
  //       field: 'name',
  //       filter: 'text',
  //       minWidth: 50,
  //     },
  //     {
  //       headerName: 'Description',
  //       field: 'description',
  //       filter: 'text',
  //     },
  //     {
  //       headerName: 'Original Value',
  //       field: 'oldValue',
  //       filter: 'text',
  //     },
  //     {
  //       headerName: 'New Value',
  //       field: 'newValue',
  //       filter: 'text',
  //     },
  //     {
  //       headerName: 'Username',
  //       field: 'username',
  //       filter: 'text',
  //     },
  //     {
  //       headerName: 'Date of Change',
  //       field: 'createdAt',
  //       filter: 'date',
  //     },
  //   ];
  // }
}
